import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Layout from '../components/Layout/Layout';
import Hero from '../components/Screens/Hero';
import NewsPosts from '../components/News/NewsPosts';
import Pagination from '../components/Global/Pagination';

// ====

const News = ({ blok, data, pageContext }) => {
  const { numPages, limit, skip, currentPage } = pageContext;
  let doc;
  let items;
  if (data) {
    doc = JSON.parse(data.index.content);
    items = data.news;
  } else {
    doc = blok;
  }
  const openGraph = {
    type: 'website',
    title: doc.title,
    description: doc.body,
    image: doc.image,
  };

  return (
    <Layout meta={doc.meta} openGraph={openGraph}>
      <Hero title={doc.title} copy={doc.body} image={doc.image} />

      <div className="container">
        {items && <NewsPosts posts={items} />}
        {numPages > 1 && (
          <Pagination numPages={numPages} currentPage={currentPage} />
        )}
      </div>
    </Layout>
  );
};

export default News;

export const QUERY = graphql`
  query NewsIndexDefaultQuery($skip: Int!, $limit: Int!) {
    # Query the data from the index page
    index: storyblokEntry(
      field_component: { eq: "news" }
      lang: { eq: "default" }
    ) {
      content
    }

    # Grab news articles
    news: allStoryblokEntry(
      filter: {
        parent_id: { eq: 20378306 }
        field_component: { eq: "news_post" }
      }
      sort: { fields: field_date_string, order: DESC }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        full_slug
        field_date_string
        content
      }
    }
  }
`;

News.propTypes = {
  pageContext: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  blok: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

News.defaultProps = {
  pageContext: null,
  blok: null,
  data: null,
};
